class ExternalFilters extends HTMLElement {
  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.swiperComponent = this.querySelector('[data-swiper]');
      this.swiperComponent?.swiper?.on('slideChange', (event) => {
        event?.isEnd ? this.classList.add('is-end') : this.classList.remove('is-end');
      });
    });
  }
}

customElements.define('external-filters', ExternalFilters);
